import { htmlLanguage } from '@codemirror/lang-html';

const VARIABLE_COMPLETION_REGEX = /\$/;
const VARIABLE_BLOCK_REGEX = /^\$$/;

let options = [
  '$sgcname;',
  '$sgcnameproto;',
  '$sgsender;',
  '$sgrecipient;',
  '$sgsdomain;',
  '$sgrdomain;',
  '$sgsusername;',
  '$sgrusername;',
  '$sgrandom;',
  '$sgmsgid;',
  '$sgmsghashid;',
  '$sgsubject;',
  '$sginternal;',
  '$sgonlyinternal;',
  '$sgexternal;'
].map((variable) => ({ label: variable, type: 'keyword' }));

const variableCompletions = (context) => {
  const before = context.matchBefore(VARIABLE_COMPLETION_REGEX);

  if (!context.explicit && !before) {
    return null;
  }

  return {
    from: before ? before.from : context.pos,
    options,
    validFor: VARIABLE_BLOCK_REGEX
  };
};

export const variableAutocomplete = (additionalOptions) => {
  if (additionalOptions) {
    options = [...options, ...additionalOptions.map(({ name }) => ({ label: `$${name};`, type: 'keyword' }))];
  }

  return htmlLanguage.data.of({
    autocomplete: variableCompletions
  });
};
